import { QueryOptions, FetchPolicy } from 'apollo-client';
import { OrderListQueryVariables as Variables } from './__generated__/OrderListQuery';
import * as query from './query.gql';

export const orderListQuery = (
  variables: Variables,
  fetchPolicy: FetchPolicy = 'network-only'
): QueryOptions<Variables> => ({
  query,
  variables,
  fetchPolicy,
});
